export const RecentProjectData = [

  {
    title: 'SwapApp Ads Website',
    detail:
      'SwapApp is a marketplace that connects sellers and buyers commission-free. With just one subscription you can offer their different offers',
    image: 'https://miro.medium.com/v2/resize:fit:600/format:webp/1*D-ejcg4WYorO4Qesl6E3CQ.png',
    buttons: [{ label: 'Demo', link: 'https://www.staging.swapapp.de/' }, { label: 'Code', link: 'https://github.com/rashiddaha' },],
    // status: 'Private Repo',
  },
  {
    title: 'Bunker Insurancer Portal',
    detail:
      'Buncker is a Insurance Portal where Users buy insurance Plans and other offers.',
    image: 'https://miro.medium.com/v2/resize:fit:600/format:webp/1*YEvzExmh1jI0JVHACmeNqQ.png',
    buttons: [{ label: 'Demo', link: 'https://medasinsurance.com/' }, { label: 'Code', link: 'https://github.com/rashiddaha' },],
    status: 'Private Repo',
  },
  {
    title: 'Online Gamehub Website',
    detail:
      'A react and django rest frmaework web app to manage tournaments online.',
    image: 'https://miro.medium.com/max/600/1*jq0JQSsX5lmJOT-BdlasjA.png',
    buttons: [{ label: 'Demo', link: 'https://www.checkmategaming.com/' }, { label: 'Code', link: 'https://github.com/rashiddaha' },],
    status: 'Private Repo',
  },
  {
    title: 'SaaS web App For Social Data Intelligence Platform For Outreach',
    detail:
      'WebFlow Based Web app developed for Social Data Analytics Platforms',
    image: 'https://miro.medium.com/max/600/1*J25oJM5TcUP4jvEaXhyyvQ.png',
    buttons: [{ label: 'Demo', link: 'https://growtoro.com/' }, { label: 'Code', link: 'https://github.com/rashiddaha' },],
    status: 'Private Repo',
  },
  {
    title: 'Speech to Text Analysis Web App',
    detail:
      'React, JavaScipt, google Speech API',
    image: 'https://miro.medium.com/max/1400/1*DoATk2RUr0zMWE46HorsCA.png',
    buttons: [{ label: 'Demo', link: 'https://voice-search.vercel.app/' }, { label: 'Code', link: 'https://github.com/rashiddaha' }],
  },
  {
    title: 'Combustify App',
    detail:
      'React Native, JavaScript, Redux, Django Rest framework',
    image: 'https://miro.medium.com/max/404/1*3toO0f3ezGPve9ctgqJg6Q.png',
    buttons: [{ label: 'Demo', link: 'https://apps.apple.com/cr/app/combustify/id1588136598' }, { label: 'Code', link: 'https://github.com/rashiddaha' }],
  },
  {
    title: 'EyeCorntrol Web App',
    detail:
      'React and AWS Lambda based ICU communication platform enabling connectivity between ventilated patients, medical teams & family',
    image: process.env.PUBLIC_URL + '/images/eye-project.png',
    buttons: [{ label: 'Demo', link: 'https://family-app-six.vercel.app/' }, { label: 'Code', link: 'https://github.com/rashiddaha' }],
  },
  // {
  //   title: 'Git Trending',
  //   detail:
  //     'Git weekly trending app made using React, CSS, Flex',
  //   image: process.env.PUBLIC_URL + '/images/git_thumb.png',
  //   buttons: [{ label: 'Demo', link: 'https://git-weekly-trending.netlify.app/' }, { label: 'Code', link: "https://github.com/bikashxsharma/weekly-trending" }],
  // },

]
